module.exports = __webpack_public_path__ + "img/savingnotes-es.dc5b5cdc.png";